// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './mailing-footer';
export * from './mailing-header';
export * from './mailing-modal.component';
// @endindex